import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import { getFullName, getEmailAddress } from 'utilities/person'
import { safeFormat } from 'utilities/date-time'
import { Wrap, Avatar, Name, Success } from './s'
import { CaptionSmall as Meta } from 'components/typography/caption'
import { InlineMessage } from 'components/message'

const Signatory = ({ seenAt, signedAt, emailDeliveryStatus, user: signatory }) => {
    const { formatMessage } = useIntl()
    const { dateLocale: locale } = useI18n()

    return (
        <Wrap {...(!!signedAt ? { className: 'signed' } : null)}>
            <Avatar
                who={{
                    ...signatory,
                    id: signatory?.id ?? signatory.email.replace(/[@\.]+/g, '-')
                }}
                size={40} />
            <div>
                <Name className="compact">{getFullName(signatory)}</Name>
                <Meta className="compact">{getEmailAddress(signatory)}</Meta>
                {(emailDeliveryStatus === 'not_delivered') && (
                    <InlineMessage
                        type="error"
                        message={formatMessage({
                            id: 'document_signing_delivery_problem_label',
                            defaultMessage: 'Delivery problem'
                        })} />
                )}
                {(!signedAt && !!seenAt) && (
                    <Meta className="compact">
                        <FormattedMessage
                            id="document_signing_email_opened_label"
                            defaultMessage="Email opened" />
                        {' · '}
                        {safeFormat(seenAt, 'PP', { locale })}
                    </Meta>
                )}
                {!!signedAt && (
                    <Meta className="compact">
                        <FormattedMessage
                            id="document_signing_status_signed"
                            defaultMessage="Signed" />
                        {' · '}
                        {safeFormat(signedAt, 'PP', { locale })}
                    </Meta>
                )}
            </div>
            {!!signedAt && <Success size={20} />}
        </Wrap>
    )
}

export default Signatory